import { transport } from '@opengov/app-core/transport';
import { useQuery } from '@tanstack/react-query';
import { customReportsQueryKeys } from './customReportsQueryKeys';

type GetPresignedUrlResponse = {
  presignedUrl: string;
  expiresIn: number;
};

type Params = {
  publicationId: string;
  spreadsheetId: string;
  fileName: string;
};

export async function getPresignedUrl({
  publicationId,
  spreadsheetId,
  fileName
}: Params): Promise<GetPresignedUrlResponse> {
  return transport
    .url(
      `/api/stories/v1/publications/${publicationId}/spreadsheets/${spreadsheetId}/presigned-url?filename=${fileName}`
    )
    .get()
    .json();
}

export function useGetPresignedUrl({ publicationId, spreadsheetId, fileName }: Params) {
  const queryKey = customReportsQueryKeys.getPresignedUrl({ publicationId, spreadsheetId, fileName });

  return useQuery({
    queryKey,
    queryFn: () => getPresignedUrl({ publicationId, spreadsheetId, fileName })
  });
}
